import SubscriptionImage from '@/assets/images/SubscriptionImage.png';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Skeleton } from '@/components/ui/skeleton';
import { useQuery } from '@apollo/client';
import { useState } from 'react';
import { GET_ALL_PLANS } from '../GraphQL/queries';

interface FirstSubscriptionProps {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setDefaultPlan: React.Dispatch<React.SetStateAction<string>>;
}

const FirstSubscription: React.FC<FirstSubscriptionProps> = ({ setOpen, setDefaultPlan }) => {
  const [selectedPlan, setSelectedPlan] = useState('');

  const { data: plans } = useQuery(GET_ALL_PLANS, {
    variables: { sort: { sessionCount: 1 } },
    onCompleted: (res) => {
      setSelectedPlan(res?.getAllPlan[0]?._id || '');
    },
  });
  const options = plans?.getAllPlan;

  const [imageLoaded, setImageLoaded] = useState(false); // State to track image loading

  const handleSelection = (value: string) => {
    setSelectedPlan(value);
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  return (
    <div className='bg-[#262633] rounded-xl overflow-hidden flex flex-row w-2/4'>
      {!imageLoaded && (
        <div className='flex-2 flex justify-center items-center bg-gray-800'>
          <Skeleton />
        </div>
      )}
      <div id='coverPage' className={`flex-2 ${!imageLoaded ? 'hidden' : ''}`}>
        <img
          src={SubscriptionImage}
          alt=''
          className='w-full h-full object-cover'
          onLoad={handleImageLoad}
        />
      </div>
      <div
        id='sub-content'
        className={`p-5 flex-1 flex flex-col gap-6 h-full ${!imageLoaded ? 'hidden' : ''}`}
      >
        <div id='content' className='flex flex-col gap-2'>
          <span className='text-2xl font-bold'>You have no Active Subscription</span>
          <span className='font-normal'>
            You don’t have any scheduled calls yet! Tap here to book a session with a trainer, set
            your fitness goals, and get started on your personalized journey.
          </span>
          <div id='sessionPacks' className='bg-[#00000021] py-4 px-[18px] rounded-xl'>
            <span className='font-bold text-base'>Choose a pack and continue</span>
            <RadioGroup
              defaultValue={selectedPlan}
              value={selectedPlan}
              onValueChange={handleSelection}
              className='space-y-3 mt-3'
            >
              {options?.map((option) => (
                <Label
                  key={option?._id || ''}
                  className={`flex items-center justify-between w-full p-4 rounded-lg cursor-pointer 
                    ${selectedPlan === option?._id ? 'bg-[#181A32] text-white border border-[#549DFF]' : 'bg-[#16181B] hover:bg-zinc-900'}`}
                >
                  <div className='flex items-center gap-3'>
                    <RadioGroupItem value={option?._id || ''} id={option?._id} />
                    <span>
                      {option?.sessionCount} {option?.sessionCount === 1 ? 'Session' : 'Sessions'}
                    </span>
                  </div>
                  <div className='flex items-center gap-2'>${option?.price?.toFixed(2)}</div>
                </Label>
              ))}
            </RadioGroup>
          </div>
        </div>
        <div id='button'>
          <Button
            id='add-sub'
            className='w-full'
            size='lg'
            onClick={() => {
              setOpen(true);
              setDefaultPlan(selectedPlan);
            }}
          >
            Buy {options?.find((option) => option?._id === selectedPlan)?.sessionCount} Sessions $
            {options?.find((option) => option?._id === selectedPlan)?.price}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FirstSubscription;
